"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOADER_VARIANT_SECONDARY = exports.LOADER_VARIANT_PRIMARY = exports.LOADER_VARIANT_ALT = exports.LOADER_ICON_FLOWER = exports.LOADER_ICON_BUTTERFLY = void 0;
exports.LOADER_ICON_BUTTERFLY = 'butterfly';
exports.LOADER_ICON_FLOWER = 'flower';
exports.LOADER_VARIANT_ALT = 'alt';
exports.LOADER_VARIANT_PRIMARY = 'primary';
exports.LOADER_VARIANT_SECONDARY = 'secondary';
